import { cache } from "@/helpers/cache"

const handleFetchError = (error: any) => {
    console.error(`Error in useFetcher: ${error}`)
    throw error
}

interface queue {
    key: string;
    isFetching: boolean;
    promise: Promise<object>;
    data: object|null;
}

let queue: queue[] = [];
const enqueue = async (key: string, cb: (resolve: (value: object | PromiseLike<object>) => void, reject: (reason?: any) => void) => void) => {
    let queueItem = queue.find(item => item.key === key);

    if (queueItem?.data) {
        return Promise.resolve(queueItem.data);
    }

    // Se una chiamata è già in corso, ritorna la Promise della chiamata esistente
    if (queueItem?.isFetching) {
        return queueItem.promise;
    }

    queueItem = {
        key,
        isFetching: true,
        promise: new Promise(cb),
        data: null
    }

    queueItem.promise.then(data => {
        queueItem.data = data;
    })

    queue.push(queueItem);
    
    return queueItem.promise;
}

const useFetcherGet = async (url: string, params: null|string[][]|Record<string, string>|string|URLSearchParams=null, ttl: number = 60) => {
    try {
        // build params into the url
        if (params) {
            const searchParams = new URLSearchParams(params)
            url = `${url}?${searchParams.toString()}`
        }

        const nonce = window.wprest_nonce || null

        // check if the response is already cached
        if (!nonce && ttl >= 0 && cache.has(url)) {
            const cached = cache.get(url)

            if (cached !== null) return cached
        }

        const response = await enqueue(url, async (res, rej) => {
            const headers = new Headers()
    
            if (nonce) {
                // make a fetch with header X-WP-Nonce: nonce
                headers.append('X-WP-Nonce', nonce)
            }
    
            try {
                const raw_response = await fetch(url, { headers: headers })
        
                const response = await raw_response.json()
    
                if (!nonce) {
                    // cache the response
                    cache.set(url, response)
                }

                res(response)
            } catch (e) {
                rej(e)
            }

            return null
        })

        return response
    } catch (error ) {
        handleFetchError(error)
    }
}


const useFetcherPost = async (url: string, data: any, headers = { 'Content-type': 'application/json charset=UTF-8' }) => {
    try {
        const raw_response = await fetch(url, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(data)
        });

        const response = raw_response.json()
        
        return response
    } catch (error) {
        handleFetchError(error)
    }
}

export {useFetcherGet, useFetcherPost}